import { StringUtils } from '@/common/utils/StringUtils';
import { forwardRef, useImperativeHandle, useState } from 'react';

export const RowCountStatusBar = forwardRef((props, ref) => {
  const [count, setCountState] = useState(null);
  const [formattedCount, setFormattedCount] = useState('-');

  // Expose imperative methods to the parent via the ref
  useImperativeHandle(
    ref,
    () => ({
      /**
       * Updates the row count and formatted count.
       * @param {number|null} newCount
       */
      setCount(newCount) {
        setCountState(newCount);
        setFormattedCount(newCount != null ? StringUtils.thousandSeparator(newCount) : '-');
      },
      getCount() {
        return count;
      },
      /**
       * Refresh method required by AG Grid. Returns true to indicate no refresh is needed.
       * @returns {boolean}
       */
      refresh() {
        return true;
      },
    }),
    [count],
  );

  return (
    <div className="ag-status-name-value ag-status-panel ag-status-panel-total-row-count">
      <span>Row Count</span>:&nbsp;
      <span id="rowCount" data-test-id="row-count" count={count} className="ag-status-name-value-value">
        {formattedCount}
      </span>
    </div>
  );
});
